import axios from "../../config/axiosConfig";
import { CREATE_WHATSAPP_PLAN, GET_WHATSAPP_PLAN, WHATSAPP_PLAN_REQUEST, DELETE_WHATSAPP_PLAN, UPDATE_WHATSAPP_PLAN, WHATSAPP_PLAN_REQUEST_FAILURE } from "../types";

export const getWhatsappPlans = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WHATSAPP_PLAN_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get("/whatsapp-plan/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_WHATSAPP_PLAN, payload: response.data?.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getWhatsappPlanById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WHATSAPP_PLAN_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      return axios.get(`/whatsapp-plan/getById/${id}`, { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_WHATSAPP_PLAN, payload: response.data });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  }
}

export const createWhatsappPlan = (whatsappPlan) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: WHATSAPP_PLAN_REQUEST });
      return axios.post("/whatsapp-plan/add", whatsappPlan,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_WHATSAPP_PLAN, payload: response.data });
        } else {
          dispatch({
            type: WHATSAPP_PLAN_REQUEST_FAILURE,
            error: "WhatsappPlan create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateWhatsappPlan = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WHATSAPP_PLAN_REQUEST });
      const { auth } = getState();
      return axios.put("/whatsapp-plan/update", { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_WHATSAPP_PLAN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: WHATSAPP_PLAN_REQUEST_FAILURE,
            error: "WhatsappPlan update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteWhatsappPlan = (id) => {
  return async (dispatch) => {
    try {
      dispatch({ type: WHATSAPP_PLAN_REQUEST });
      return axios.delete(`/whatsapp-plan/delete/${id}`).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_WHATSAPP_PLAN, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: WHATSAPP_PLAN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
